<template>
  <el-form ref="formData" :model="formData" :rules="rules" size="small">
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item
          :label="$l('INDEX.form_label_containerName') || '箱型'"
          prop="containerCode"
        >
          <dict-select
            filterable
            v-model="formData.containerCode"
            url="/factory/masterContainer/dictSelect"
            :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            size="small"
            clearable
            :selectedLabel.sync="formData.containerName"
          >
          </dict-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          :label="$l('INDEX.form_label_extendParameter') || '订舱放大系数(m)'"
        >
          <el-input-number
            v-model="formData.extendParameter"
            controls-position="right"
            style="width:100%"
            :max="1"
            :min="0"
            :step="0.01"
            :precision="2"
          >
          </el-input-number>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  data() {
    return {
      formData: {},
      rules: {
        containerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择箱型',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async confirm() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)

      this.$api
        .masterContainerDetailApi({
          containerCode: this.formData.containerCode,
        })
        .then((res) => {
          const data = { ...this.formData, ...res.body }
          this.$emit('confirm', data)
          this.$nextTick(() => {
            this.formData = {}
          })
          this.$emit('close')
        })
    },
  },
}
</script>
